module.exports = __webpack_public_path__ + "static/media/result-0.6a9529dc.png";